import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Label,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { useTheme } from '@mui/material';
import { Conversion } from '../../@types/api';

type data = {
  month: string;
  converted: number;
  previousConverted: number;
};
const createData = (
  month: string,
  converted: number,
  previousConverted: number
) => {
  return { month, converted, previousConverted };
};

const projectAllData = (data: Conversion[]) => {
  if (!data) return [];
  const arr: data[] = [];
  data.forEach((element) => {
    arr.push(
      createData(
        element.month.substring(0, 3),
        element.converted,
        element.previousConverted
      )
    );
  });
  return arr;
};

interface Props {
  data: Conversion[];
}
const TurnoverAmount: React.FC<Props> = ({ data }) => {
  const theme = useTheme();
  const chartData: data[] = projectAllData(data);
  return (
    <ResponsiveContainer width={'100%'} height={300}>
      <BarChart
        data={chartData}
        margin={{
          top: 16,
          right: 16,
          bottom: 40,
          left: 24,
        }}
      >
        <XAxis dataKey='month' stroke={theme.palette.primary.main} />
        <YAxis stroke={theme.palette.primary.main} dataKey='converted'>
          <Label
            angle={270}
            position='left'
            style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
          >
            Amount
          </Label>
        </YAxis>
        <Tooltip />
        <Legend />
        <Bar dataKey='converted' fill={theme.palette.primary.main} />
        <Bar dataKey='previousConverted' fill={theme.palette.secondary.main} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TurnoverAmount;
